module.exports = __webpack_public_path__ + "static/media/special.e7dffcf0.png";